import UNIVERSAL from "../../config/config";
import {
  SET_MARK_LIST,
  SET_TOTAL_MARK,
  SET_GROUP_DATA,
  SET_RANK,
  SET_LEADERBOARD_DATA,
  SET_JAMIAT_LEADERBOARD_DATA,
  SET_JAMAAT_LEADERBOARD_DATA,
} from "../../constants/commonConst";
import { set_loader, unset_loader } from "../loader/loaderAction";
import md5 from "md5";
var base64 = require("base-64");
const authToken = localStorage.getItem("authToken");
export function setMarkList(payload) {
  return {
    type: SET_MARK_LIST,
    payload: payload,
  };
}

export function setTotalMark(payload) {
  return {
    type: SET_TOTAL_MARK,
    payload: payload,
  };
}

export function setGroupData(payload) {
  return {
    type: SET_GROUP_DATA,
    payload: payload,
  };
}

export function setRank(payload) {
  return {
    type: SET_RANK,
    payload: payload,
  };
}

export function setLeaderboardData(payload) {
  return {
    type: SET_LEADERBOARD_DATA,
    payload: payload,
  };
}
//new
export function setJamiatLeaderboardData(payload) {
  return {
    type: SET_JAMIAT_LEADERBOARD_DATA,
    payload: payload,
  };
}
export function setJamaatLeaderboardData(payload) {
  return {
    type: SET_JAMAAT_LEADERBOARD_DATA,
    payload: payload,
  };
}

// GET APIs
export const getMarkList = (its_id, id, isAdmin = false) => {
  console.log("Try this mark list", isAdmin);
  return (dispatch) => {
    dispatch(set_loader());
    let myHeaders = new Headers();
    myHeaders.append("Authorization", "Basic " + authToken);
    let requestOptions = {
      method: "GET",
      headers: myHeaders,
    };
    if (isAdmin) {
      return fetch(
        `${process.env.REACT_APP_API_URL}user/obtain_marks_list_by_user_id/${id}/${its_id}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((responseJson) => {
          dispatch(unset_loader());
          dispatch(setMarkList(responseJson.data));
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      return fetch(
        `${process.env.REACT_APP_API_URL}user/obtain_marks_list/${id}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((responseJson) => {
          dispatch(unset_loader());
          dispatch(setMarkList(responseJson.data));
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
};

export const getTotalMark = (its_id, id, isAdmin = false) => {
  return (dispatch) => {
    dispatch(set_loader());
    let myHeaders = new Headers();
    myHeaders.append("Authorization", "Basic " + authToken);
    let requestOptions = {
      method: "GET",
      headers: myHeaders,
    };
    if (isAdmin) {
      return fetch(
        `${process.env.REACT_APP_API_URL}user/total_marks_list_by_user_id/${id}/${its_id}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((responseJson) => {
          dispatch(unset_loader());
          dispatch(setTotalMark(responseJson.data));
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      return fetch(
        `${process.env.REACT_APP_API_URL}user/total_marks/${id}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((responseJson) => {
          dispatch(unset_loader());
          dispatch(setTotalMark(responseJson.data));
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
};

export const getGroupData = (id) => {
  return (dispatch) => {
    dispatch(set_loader());
    let myHeaders = new Headers();
    myHeaders.append("Authorization", "Basic " + authToken);
    let requestOptions = {
      method: "GET",
      headers: myHeaders,
    };
    return fetch(
      `${process.env.REACT_APP_API_URL}user/group_data/${id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((responseJson) => {
        dispatch(unset_loader());
        dispatch(setGroupData(responseJson.data));
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

export const getRank = (its_id, id, isAdmin = false) => {
  console.log("Try this", isAdmin);
  return (dispatch) => {
    dispatch(set_loader());
    let myHeaders = new Headers();
    myHeaders.append("Authorization", "Basic " + authToken);
    let requestOptions = {
      method: "GET",
      headers: myHeaders,
    };
    if (isAdmin) {
      return fetch(
        `${process.env.REACT_APP_API_URL}user/rankByUserID/${id}/${its_id}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((responseJson) => {
          dispatch(unset_loader());
          dispatch(setRank(responseJson.data));
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      return fetch(
        `${process.env.REACT_APP_API_URL}user/rank/${id}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((responseJson) => {
          dispatch(unset_loader());
          dispatch(setRank(responseJson.data));
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
};

export const getLeaderboard = (its_id, group_id) => {
  return (dispatch) => {
    dispatch(set_loader());
    let myHeaders = new Headers();
    myHeaders.append("Authorization", "Basic " + authToken);
    let requestOptions = {
      method: "GET",
      headers: myHeaders,
    };
    return fetch(
      `${process.env.REACT_APP_API_URL}user/top100Users/${group_id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((responseJson) => {
        dispatch(unset_loader());
        dispatch(setLeaderboardData(responseJson.data));
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

//New
export const getJamiatLeaderboard = (group_id, jamiat_id) => {
  return (dispatch) => {
    dispatch(set_loader());
    let myHeaders = new Headers();
    myHeaders.append("Authorization", "Basic " + authToken);
    let requestOptions = {
      method: "GET",
      headers: myHeaders,
    };

    return fetch(
      `${process.env.REACT_APP_API_URL}user/top100UsersByJamiatID/${group_id}/${jamiat_id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((responseJson) => {
        dispatch(unset_loader());

        dispatch(setJamiatLeaderboardData(responseJson.data));
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

export const getJamaatLeaderboard = (group_id, jamaat_id) => {
  return (dispatch) => {
    dispatch(set_loader());
    let myHeaders = new Headers();
    myHeaders.append("Authorization", "Basic " + authToken);
    let requestOptions = {
      method: "GET",
      headers: myHeaders,
    };

    return fetch(
      `${process.env.REACT_APP_API_URL}user/top100UsersByJamaatID/${group_id}/${jamaat_id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((responseJson) => {
        dispatch(unset_loader());

        dispatch(setJamaatLeaderboardData(responseJson.data));
      })
      .catch((error) => {
        console.log(error);
      });
  };
};
